import UAParser from 'ua-parser-js';
import { DeviceType, DeviceInfo } from '../types/device';

/**
 * Get device type from UA Parser result
 * @param uaResult The result from UAParser
 * @returns DeviceType enum value based on the device type
 */
const getDeviceTypeFromUA = (uaResult: UAParser.IResult): DeviceType => {
  const deviceType = uaResult.device.type;
  
  if (['mobile', 'tablet', 'wearable'].includes(deviceType || '')) {
    return DeviceType.MOBILE;
  } else if (deviceType === 'console') {
    return DeviceType.TERMINAL;
  } else if (!deviceType || deviceType === 'desktop') {
    return DeviceType.DESKTOP;
  } else {
    return DeviceType.UNKNOWN;
  }
};

/**
 * Get detailed device information using ua-parser-js
 * @returns DeviceInfo object with all available device details
 */
export const getDeviceInfo = (): DeviceInfo => {
  // Initialize the UAParser
  const parser = new UAParser();
  const result = parser.getResult();
  
  // Get device type from UA Parser
  const deviceType = getDeviceTypeFromUA(result);
  
  return {
    deviceType,
    vendor: result.device.vendor || undefined,
    model: result.device.model || undefined,
    os: result.os.name || undefined,
    osVersion: result.os.version || undefined,
    browser: result.browser.name || undefined,
    browserVersion: result.browser.version || undefined
  };
};